import React from 'react';
import PropTypes from 'prop-types';

import { TabFilter } from 'common/components/svgs';

const DropFilterIcon = ({ color }) => <TabFilter width={12} height={12} fill={color} />;

DropFilterIcon.propTypes = {
  color: PropTypes.string.isRequired,
};

export default DropFilterIcon;
